import { diagramAnimationDuration } from '../utils/animation.js'

export const animatePie = (pieItems, pie) => {
  const sizeFactor = getSizeFactor(pieItems)
  const accumulatedValues = accumulate(pieItems, sizeFactor)
  pieItems.forEach((item, idx) => {
    animatePieItem(accumulatedValues, idx, pie)
  })
}

const getSizeFactor = (pieItems) => {
  const size = Array.from(pieItems)
    .reduce((accumulator, item) => parseItemAndIncrement(accumulator, item), 0)
  return 100 / size
}

const parseItemAndIncrement = (accumulator, item) => {
  const itemJSON = JSON.parse(item.dataset.item)
  return accumulator + parseFloat(itemJSON.value)
}

const accumulate = (pieItems, sizeFactor) => {
  return Array.from(pieItems).reduce((acc, item, idx) => {
    const itemJSON = JSON.parse(item.dataset.item)
    if (acc.length > 0) {
      acc.push(acc[idx - 1] + parseFloat(itemJSON.value) * sizeFactor)
    } else {
      acc.push(parseFloat(itemJSON.value) * sizeFactor)
    }
    return acc
  }, [])
}

const animatePieItem = (accumulatedValues, idx, pie) => {
  const step = accumulatedValues[idx] / diagramAnimationDuration
  let counter = 0
  const animationInterval = setInterval(() => {
    if (counter < diagramAnimationDuration) {
      const currentValue = step * counter
      pie.style.setProperty(`--pie-size-${idx + 1}`, `${currentValue}%`)
      counter++
    } else {
      pie.style.setProperty(`--pie-size-${idx + 1}`, `${accumulatedValues[idx]}%`)
      clearInterval(animationInterval)
    }
  }, 1)
}
